import React from 'react';
import { ShowButton } from 'react-admin';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import Journey from './Journey';

const defaultCardStyle = {
    width: '100%',
    margin: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top'
};

const JourneyGrid = ({ ids, data, basePath }) => (
    <div style={{ margin: '1em' }}>
        {ids.map(id =>
            <Card key={id} style={defaultCardStyle}>
                <CardHeader title={data[id].title} />
                <CardContent>
                    {renderJourney(data[id], id)}
                </CardContent>
                <CardActions style={{ textAlign: 'right' }}>
                    <ShowButton label="Analyze" resource="insights" basePath={basePath} record={data[id]} />
                </CardActions>
            </Card>
        )}
    </div>
);

JourneyGrid.defaultProps = {
    data: {},
    ids: [],
};

const renderJourney = (datum, key) => {
    return <Journey {...datum} />
}

export default JourneyGrid;


// WEBPACK FOOTER //
// ./src/components/JourneyGrid.js